import { render, staticRenderFns } from "./user-feedback.vue?vue&type=template&id=fbd84e1c&scoped=true&"
import script from "./user-feedback.vue?vue&type=script&lang=js&"
export * from "./user-feedback.vue?vue&type=script&lang=js&"
import style0 from "./user-feedback.vue?vue&type=style&index=0&id=fbd84e1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd84e1c",
  null
  
)

export default component.exports